import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, OnInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { I18nModule, WindowRef } from '@spartacus/core';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { SpinnerModule } from '@spartacus/storefront';
import { GenLoadingEnum } from 'src/app/generac/enums/loading.enum';
import { GenDocumentListItemComponent } from 'src/app/generac/features/product/document-list/document-list-item/document-list-item.component';
import { GenDocumentsListPaginationMapped, GenDocumentsListPagination, GenDocumentsResponse, GenDocument } from 'src/app/generac/models/document.model';
import { GenDocumentService } from 'src/app/generac/services/document.service';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'gen-product-document-list',
  templateUrl: './product-document-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule, GenDocumentListItemComponent, I18nModule, SpinnerModule]
})
export class GenProductDocumentListComponent implements OnInit {
  private subscription = new Subscription();

  searchBy: string = 'model';
  spSearchCode: string;

  currentPage: number = 0;
  pageSize: number = 5;
  defaultPageSize: number = this.pageSize;
  isMobileView: boolean;

  pagination: GenDocumentsListPaginationMapped | GenDocumentsListPagination;
  documents: GenDocument[];

  GenLoadingEnum = GenLoadingEnum;
  loading: GenLoadingEnum = GenLoadingEnum.Idle;

  @HostListener('window:resize')
  onResize() {
    this.isMobileView = this.winRef?.nativeWindow.innerWidth < 768;
  }

  constructor(
      protected documentService: GenDocumentService,
      protected activatedRoute: ActivatedRoute,
      private cdr: ChangeDetectorRef,
      protected winRef: WindowRef,
  ) { 
    this.isMobileView = this.winRef?.nativeWindow.innerWidth < 768;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.activatedRoute.params
          .pipe(
            tap(params => {
                this.spSearchCode = params?.productCode || '';
            }),
            switchMap(() => this.getDocuments())
          )
          .subscribe()
      );
  }

  getDocuments(): Observable<any> {
      this.loading = GenLoadingEnum.Loading;

      return this.documentService.getDocuments(this.searchBy, this.spSearchCode, this.currentPage, this.pageSize).pipe(
        tap((res: GenDocumentsResponse) => {
          this.documents = res.documents;
          this.pagination = res.pagination;
          this.cdr.markForCheck();
        }),
        catchError(() => this.loading = GenLoadingEnum.Failed),
        finalize(() => this.loading = GenLoadingEnum.Loaded)
      )
  }

  toggleDocuments(): void {
    const isExpanded = this.documents?.length === this.pagination?.totalResults;

    if (isExpanded) {
      this.pageSize = 5;

      this.subscription.add(
        this.getDocuments().subscribe(() => {
          const target = document.getElementsByClassName('Tabs')[0] as HTMLElement;
          if (target) {
            window.scrollTo({
              top: target.offsetTop - 65,
              behavior: 'smooth'
            });
          }
        })
      );
    } else {
      this.pageSize += 20;
      this.subscription.add(this.getDocuments().subscribe());
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
